// extracted by mini-css-extract-plugin
export default {"thinScrollbar":"Sidebar_thinScrollbar__ub2ed","container":"Sidebar_container__GyhoA","glowingBadge":"Sidebar_glowingBadge__MbWpU","sidebarWrapper":"Sidebar_sidebarWrapper__PJzL9"};